document.addEventListener('DOMContentLoaded', function () {
    const ACTION_EVENTS = ['click', 'keydown'];
    const MOUSE_EVENTS = ['mousemove', 'mouseover', 'mouseenter'];
    const fullScreenGalleryButtons = document.querySelectorAll('.product-zoom-gallery, .product-zoom-button-items');
    const fullScreenThumbnailButtons = document.querySelectorAll('.product-gallery__thumbnail');
    const productFullscreenGallery = document.querySelector('product-fullscreen-gallery, .product-zoom-button-items-exit');
    const galleryMedias = document.querySelectorAll('.product-gallery__media, .product-fullscreen-gallery__media');
    
    // Track previously focused element and focus trap handler
    let previouslyFocusedElement = null;
    let focusTrapHandler = null;

    const fullScreenHideShow = (targetIndex, fullscreenGallery, isShow = true) => {
        const body = document.body;
        const allImages = fullscreenGallery.querySelectorAll('[data-index]');

        allImages.forEach((img) => {
            if (img.getAttribute('data-index') === targetIndex) {
                img.classList.add('active');
                img.setAttribute('tabindex', '0');
                return;
            }

            img.classList.remove('active');
            img.setAttribute('tabindex', '-1');
        });

        fullscreenGallery.setAttribute('data-active-index', targetIndex);
        fullscreenGallery.setAttribute('aria-hidden', !isShow ? 'true' : 'false');
        fullscreenGallery.classList.toggle('active', isShow);

        fullScreenThumbnailButtons.forEach(function (thumbnailButton) {
            const thumbIndex = thumbnailButton.getAttribute('data-thumb-index');
            thumbnailButton.setAttribute('aria-current', thumbIndex === targetIndex);
            thumbnailButton.classList.toggle('active', thumbIndex === targetIndex);
        });

        requestAnimationFrame(() => {
            fullscreenGallery?.focus();
            fullscreenGallery.querySelector(`[data-index="${targetIndex}"]`)?.focus();
        });

        body.classList.toggle('pswp__scroll-wrap', isShow);

        // Generate focus trap on full gallery when open
        if (isShow) {            
            const focusableElements = fullscreenGallery.querySelectorAll('button:not(.product-zoom-button-items-exit), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
            const firstFocusableElement = focusableElements[0];
            const lastFocusableElement = focusableElements[focusableElements.length - 1];

            // Create and store the focus trap handler
            focusTrapHandler = (e) => {
                const isTabPressed = (e.key === 'Tab' || e.keyCode === 9);

                if (!isTabPressed) {
                    return;
                }

                // Focus trap: only prevent default and redirect focus when at boundaries
                if (e.shiftKey) { // Shift + Tab
                    if (document.activeElement === firstFocusableElement) {
                        lastFocusableElement.focus();
                        e.preventDefault();
                    }
                } else { // Tab
                    if (document.activeElement === lastFocusableElement) {
                        firstFocusableElement.focus();
                        e.preventDefault();
                    }
                }
            };

            fullscreenGallery.addEventListener('keydown', focusTrapHandler);
        }

        // If the targetIndex == -1, remove focus trap and focus the last focused element before opening the gallery
        if (parseInt(targetIndex) === -1) {
            // Remove focus trap event listener
            if (focusTrapHandler) {
                fullscreenGallery.removeEventListener('keydown', focusTrapHandler);
                focusTrapHandler = null;
            }
            
            // Restore focus to the previously focused element
            if (previouslyFocusedElement && typeof previouslyFocusedElement.focus === 'function') {
                requestAnimationFrame(() => {
                    previouslyFocusedElement.focus();
                    previouslyFocusedElement = null;
                });
            }
        }
    };

    // Mousemove event to position zoom button
    galleryMedias.forEach(function (media) {
        MOUSE_EVENTS.forEach((eventType) => {
            media.addEventListener(eventType, (event) => {
                const singleZoomButton = media.querySelector('.product-zoom-button-items, .product-zoom-button-items-exit');
                const rect = media.getBoundingClientRect();
                const x = event.clientX - rect.left - (singleZoomButton.offsetWidth / 2);
                const y = event.clientY - rect.top - (singleZoomButton.offsetHeight / 2);

                if (singleZoomButton) {
                    singleZoomButton.classList.add('visible');
                    singleZoomButton.style.cssText = `--_cursor-x: ${x}px; --_cursor-y: ${y}px;`;
                }

            });
        });
        media.addEventListener('mouseleave', (event) => {
            const zoomButton = media.querySelector('.product-zoom-button-items, .product-zoom-button-items-exit');

            if (zoomButton) {
                zoomButton.classList.remove('visible');
            }
        });
    });

    fullScreenThumbnailButtons.forEach(function (thumbnailButton) {
        ACTION_EVENTS.forEach(function (eventType) {
            thumbnailButton.addEventListener(eventType, function (event) {
                if (eventType === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }
                event.stopPropagation();
                const currentTarget = event.currentTarget;
                const fullscreenGallery = document.getElementById(currentTarget.closest('product-fullscreen-gallery').id);
                const targetIndex = currentTarget.getAttribute('data-thumb-index');

                if (!fullscreenGallery) {
                    return;
                }

                fullScreenHideShow(targetIndex, fullscreenGallery);
            });
        });
    });

    fullScreenGalleryButtons.forEach(function (button) {
        ACTION_EVENTS.forEach(function (eventType) {
            button.addEventListener(eventType, function (event) {
                if (eventType === 'keydown' && event.key !== 'Enter' && event.key !== ' ') {
                    return;
                }
                const currentTarget = event.currentTarget;
                const fullscreenGallery = document.getElementById(currentTarget.getAttribute('aria-controls'));
                const targetIndex = currentTarget.getAttribute('data-index');

                if (!fullscreenGallery) {
                    return;
                }
                previouslyFocusedElement = document.activeElement;

                fullScreenHideShow(targetIndex, fullscreenGallery);
            });
        });
    });

    // Close fullscreen gallery on Escape key press
    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            productFullscreenGallery.setAttribute('aria-hidden', 'true');
            productFullscreenGallery.classList.remove('active');
            document.body.classList.remove('pswp__scroll-wrap');
            fullScreenHideShow(-1, productFullscreenGallery, false);
        }
    });

    // Close fullscreen gallery on click the image
    productFullscreenGallery?.addEventListener('click', function (event) {
        this.setAttribute('aria-hidden', 'true');
        this.classList.remove('active');
        document.body.classList.remove('pswp__scroll-wrap');
        fullScreenHideShow(-1, this, false);
    });
});